import { render, staticRenderFns } from "./ExRecord.vue?vue&type=template&id=0bed6adb&"
import script from "./ExRecord.vue?vue&type=script&lang=js&"
export * from "./ExRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports